export const openNewTab = (url: string, target: string = '_blank'): Promise<Window | null> => {
  return new Promise((resolve, reject) => {
    if (typeof window === 'undefined') {
      reject(new Error('Failed to open new tab. Window not found!'));
    }

    const newWindow = window.open(url, target);

    if (!newWindow) {
      // Reject if window.open return null
      reject(new Error('Failed to open new tab'));
    } else {
      resolve(newWindow);
    }
  });
};
